// export { Welcome } from "./1_Welcome";
export { Intro } from "./2_Intro";
export { ZonePicker } from "./3_ZonePicker";
export { ColorPicker } from "./4_ColorPicker";
export { Finish } from "./5_Finish";
export { Form } from "./5_Form";
export { Payment } from "./5_Payment";
export { EcardCustomizer } from "./7_EcardCustomizer";
export { ShareEcard } from "./8_ShareEcard";
